import { render, staticRenderFns } from "./FormVersion.vue?vue&type=template&id=20b6c5dd&scoped=true"
import script from "./FormVersion.vue?vue&type=script&lang=js"
export * from "./FormVersion.vue?vue&type=script&lang=js"
import style0 from "./FormVersion.vue?vue&type=style&index=0&id=20b6c5dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_lodash@4.17.21_prettier@3.5.3_react@19.0.0_vue-template-c_l4y5rdbexcxjh5nqfbzyfvj2aq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b6c5dd",
  null
  
)

export default component.exports